import { endangeredAreaAttributes, EndangeredAreaGminyAttributes, KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes, landSlideAttributes, LandslideDevelopment, LandslideGminyAttributes, LandslideRoadCategories } from '../../contexts/krFormContext';
import { ProtocolAttributes, poFormTypes } from '../../contexts/poFormContext';
import { ObjectType, PatternType } from '../../contexts/types/card';
import { isIdentityType } from '../idNumber';
import { Dictionary } from '../dictionariesFromLayers';
import { monitoringTypeCheck } from '../form';
import { CalcField } from '../form/calcField';
import { Option } from '../../components/shared/selectInput/types/selectInputProps'
import { formatDate } from '../dateHelper';

export enum ErrorMessages {
    RequiredField = "Pole jest wymagane",
    InvalidFormat = "Niepoprawny format",
    InvalidFormatNumber = "Niepoprawny format. Należy podać liczbę całkowitą",
    LaterThanDateNow = "Data nie może być większa niż data bieżąca"
}

export enum FormulaMsg {
    KoD = "Wartość niezgodna ze wzorem, zależna od wysokości i nachylenia skarpy oraz długości osuwiska",
    KoN = "Wartość niezgodna ze wzorem, zależna od wysokości i nachylenia osuwiska, długości koluwium oraz wysokości skarpy",
    StN = "Wartość niezgodna ze wzorem, zależna od długości i wysokości stoku",
    OsR = "Wartość niezgodna ze wzorem, zależna od wysokości min i max osuwiska"
}

type FillDateCompare = {
    fillDate?: number,
    fillDateFrom?: number,
    fillDateTo?: number
}

export const validation = (config?: configValidation, value?: any, checkAdditionalDesc?: boolean, isFoto?: boolean, fillDateCompare?: FillDateCompare) => {
    let text: string = "";
    if (config?.required && required(value)) return ErrorMessages.RequiredField;
    if (config?.intType && intTypeValidation(value)) return ErrorMessages.InvalidFormatNumber;
    if (config?.stringType && stringTypeValidation(value)) return ErrorMessages.InvalidFormat;
    if (config?.minCharacters && minCharacters(value, config?.minCharacters?.minNumberOfCharacters)) return config?.minCharacters?.errorMsg;
    if (config?.maxCharacters && maxCharacters(value, config?.maxCharacters?.maxNumberOfCharacters)) return config?.maxCharacters?.errorMsg;
    if (config?.requiredText && requiredText(value, config.requiredText)) {
        return `Opis musi posiadać frazę "${config.requiredText.text}"`;
    }
    if (config?.forbiddenText && forbiddenText(value, config.forbiddenText)) {
        return `Opis nie może zawierać frazy "${config.forbiddenText.text}"`;
    }
    if (config?.identityType && identityTypeValidation(value)) return 'Należy podać 6-cyfrową wartość';
    if (config?.noLaterThanDateNow && notLaterThanDateNow(value)) return ErrorMessages.LaterThanDateNow;
    if (config?.noSmallerThan && noSmallerThan(value, config.noSmallerThan.minValue)) return config.noSmallerThan.errorMsg;
    if (config?.noSmallerThanDate && noSmallerThanDate(value, config.noSmallerThanDate.minValue)) return config.noSmallerThanDate.errorMsg;
    if (config?.noBiggerThanDate && noBiggerThanDate(value, config.noBiggerThanDate.minValue)) return config.noBiggerThanDate.errorMsg;
    if (config?.requiredArrayElement && requiredArrayElement(value)) return "Wymagane podanie przynajmniej jednej wartości";
    if (config?.requiredFieldOfArrayElement && requiredFieldOfArrayElement(value, config.requiredFieldOfArrayElement.requireField)) return config.requiredFieldOfArrayElement.errorMsg;
    if (config?.requiredAnyFieldOfArrayElement && requiredAnyFieldOfArrayElement(value, config.requiredAnyFieldOfArrayElement.requireField)) return config.requiredAnyFieldOfArrayElement.errorMsg;
    if (config?.plotNumber && isValidPlotNumber(value) === false) return "Format niezgodny z wymaganym (WWPPGG_R.XXXX.NDZ, wartości rozdzielone ;)";
    if (config?.elaboratorsRequired && required(value)) return "Należy dodać osobę opracowującą";
    if (config?.rocksRequired && required(value)) {
        return "Należy dodać przynajmniej jedno wydzielenie"
    };
    if (config?.coluvialMaterial && required(value)) return "Należy zaznaczyć przynajmniej jeden rodzaj";
    if (config?.landUseRequired && required(value)) return "Należy zaznaczyć przynajmniej jeden";
    if (config?.developmentsRequired && requiredDevelopments(value)) return "Należy podać czas powstania";
    if (config?.waterManifestationRequired && required(value)) return "Należy zaznaczyć przynajmniej jeden przejaw wód";
    if (config?.publications && required(value)) return "Należy dodać przynajmniej jedną publikację lub dokument";
    if (config?.rastersRequired && required(value) && !checkAdditionalDesc) return "Należy dodać przynajmniej jeden plik";
    if (config?.rastersRequired && value != null && value !== undefined && isFoto) {
        if (value instanceof Array) {
            var photos = value as any[];
            for (var i = 0; i < photos.length; i++) {
                if (photos[i].details !== undefined && photos[i].details != null &&
                    photos[i].details.rodzaj !== undefined && photos[i].details.rodzaj !== null && photos[i].details.rodzaj === "foto") {
                    if (photos[i].details.opis == null) return "Należy dodać opis do fotografii " + photos[i].details.pliK_NAZWA;
                    if (photos[i].details.opis.length !== undefined && photos[i].details.opis.length < 10) return "Należy dodać opis do fotografii " + photos[i].details.pliK_NAZWA + " (minimum 10 znaków)";
                }
            }
        }
    }
    if (config?.landslideMonitoringRegistersRequired && config?.landslideMonitoringRegistersRequired.hasMonitoring && required(value)) return "Należy dodać przynajmniej jeden monitoring";
    if (config?.isMonitoring && isMonitoring(value, config.isMonitoring.hasData)) {
        return value === 1 ? "Niezgodność pól: brak danych pochodzących z monitoringu w tabeli" : "Niezgodność pól: istnieją dane pochodzące z monitoringu w tabeli";
    }
    if (config?.elaboratorsPermissions && elaboratorsPermissions(value) === false) return "co najmniej jedna osoba musi posiadać odpowiednie uprawnienia (numeru uprawnień geologicznych w kategorii VI, VII lub VIII lub numeru decyzji uznającej kwalifikacje zawodowe w dziedzinie geologii lub być „osobą świadcząca usługi transgraniczne”)";
    if (config?.noSmallerThanCompared && noSmallerThanCompared(value, config.noSmallerThanCompared.compareValue)) return config.noSmallerThanCompared.errorMsg;
    if (config?.noSmallerOrEqualThanCompared && noSmallerOrEqualThanCompared(value, config.noSmallerOrEqualThanCompared.compareValue)) return config.noSmallerOrEqualThanCompared.errorMsg;
    if (config?.noSmallerThanComparedSecond && noSmallerThanCompared(value, config.noSmallerThanComparedSecond.compareValue)) return config.noSmallerThanComparedSecond.errorMsg;
    if (config?.noSmallerOrEqualThanComparedSecond && noSmallerOrEqualThanCompared(value, config.noSmallerOrEqualThanComparedSecond.compareValue)) return config.noSmallerOrEqualThanComparedSecond.errorMsg;
    if (config?.noBiggerThanCompared && config?.noBiggerThanCompared.compareValue && config?.noBiggerThanCompared.compareValue !== undefined &&
        config?.noBiggerThanCompared.compareValue !== null
        && noBiggerThanCompared(value, config.noBiggerThanCompared.compareValue)) return config.noBiggerThanCompared.errorMsg;
    if (config?.noBiggerOrEqualThanCompared && config?.noBiggerOrEqualThanCompared.compareValue && config?.noBiggerOrEqualThanCompared.compareValue !== undefined &&
        config?.noBiggerOrEqualThanCompared.compareValue !== null
        && noBiggerOrEqualThanCompared(value, config.noBiggerOrEqualThanCompared.compareValue)) return config.noBiggerOrEqualThanCompared.errorMsg;
    if (config?.requiredOneOfTwo && requiredOneOfTwo(value, config.requiredOneOfTwo.secondValue)) return config.requiredOneOfTwo.errorMsg;
    if (config?.noBiggerThanComparedSecond && config?.noBiggerThanComparedSecond.compareValue &&
        config?.noBiggerThanComparedSecond.compareValue !== undefined && config?.noBiggerThanComparedSecond.compareValue !== null
        && noBiggerThanCompared(value, config.noBiggerThanComparedSecond.compareValue)) return config.noBiggerThanComparedSecond.errorMsg;
    if (config?.inRange && inRange(value, config.inRange.minRange, config.inRange.maxRange)) return config.inRange.errorMsg;
    if (config?.inRangeOrEmpty && inRangeOrEmpty(value, config.inRangeOrEmpty.minRange, config.inRangeOrEmpty.maxRange)) return config.inRangeOrEmpty.errorMsg;
    if (config?.noLaterThan2020 && notLaterThan2020(value)) return "Data nie może być wcześniejsza niż 18.02.2021";
    if (config?.laterThan2020 && LaterThan2020(value)) return "Data nie może być późniejsza niż 17.02.2021";
    if (config?.formula && checkFormula(value, config?.formula)) return config.formula.msg;
    if (config?.roadAvailibility && checkRoadAvailability(value, config?.roadAvailibility.compareValue, config?.roadAvailibility.dictRoadCategory, config?.roadAvailibility.dictCommInfra)) return config?.roadAvailibility.errorMsg;
    if (fillDateCompare && fillDateCompare.fillDate && (fillDateCompare.fillDateFrom || fillDateCompare.fillDateTo)) {
        if (fillDateCompare.fillDateFrom && fillDateCompare.fillDate < fillDateCompare.fillDateFrom) {
            return `Wybrana wartość słownika nie jest odpowiednia dla daty wypełnienia, wartość słownika jest ważna od ${formatDate(new Date(fillDateCompare.fillDateFrom), false)}`
        }
        else if (fillDateCompare.fillDateTo && fillDateCompare.fillDate > fillDateCompare.fillDateTo) {
            return `Wybrana wartość słownika nie jest odpowiednia dla daty wypełnienia, wartość słownika jest ważna do ${formatDate(new Date(fillDateCompare.fillDateTo), false)}`
        }
    }

    return text;
}

const required = (value: any) => {
    return ((value === null || value === "" || value === undefined || value.length === 0) && value !== 0);
}

const intTypeValidation = (value: any) => {
    var regex: RegExp = /^([+-]?[1-9]\d*|0)$|^$/;
    return !regex.test(value);
}

const minCharacters = (value: string, minNo: number) => {
    return value.length < minNo;
}

const maxCharacters = (value: string, maxNo: number) => {
    return value.length > maxNo;
}

const stringTypeValidation = (value: any) => {

    return false;
}

const requiredText = (value: string, config: ValidationSubtext) => {
    return !value.toLowerCase().includes(config.text);
}

const forbiddenText = (value: string, config: ValidationSubtext) => {
    if (value) {
        return value.includes(config.text);
    }
    return false;
}

const identityTypeValidation = (value: any) => {
    return !isIdentityType(value);
}

export const notLaterThanDateNow = (date: any) => {
    return date > new Date(Date.now());
}

export const notLaterThan2020 = (date: any) => {
    return date < new Date("2021-02-17");
}

export const LaterThan2020 = (date: any) => {
    return date > new Date("2021-02-17");
}

const inRange = (value: any, min: number, max: number) => {
    return value !== '' && (value < min || value > max);
}

const inRangeOrEmpty = (value: any, min: number, max: number) => {
    if (isEmpty(value)) return false;
    return inRange(value, min, max);
}

export const noSmallerThan = (value: any, min: number) => {
    return value !== '' && parseFloat(value) < min;
}

export const noSmallerThanDate = (value: any, min: Date) => {
    return value !== '' && value < min;
}

export const noBiggerThanDate = (value: any, max: Date) => {
    return value !== '' && max !== null && value > max;
}

export const isMonitoring = (value: any, hasData: any) => {
    return value === 1 ? !hasData : hasData;
}

export const requiredFieldOfArrayElement = (value: any, requireField: string) => {
    var validatedArray = value.filter((item: any) => item[requireField] === null || item[requireField] === undefined || item[requireField] === "");
    return value.length > 0 && validatedArray.length > 0;
}

export const requiredAnyFieldOfArrayElement = (value: any, requireField: string) => {
    return !value?.some((item: any) => item[requireField] !== null && item[requireField] !== undefined && item[requireField] !== "");
}

export const requiredArrayElement = (value: any) => {
    return !value || value.length === 0;
}

export const isValidPlotNumber = (value: any) => {
    if (!value) return true;
    const numbers = value.split(";");
    return numbers.every(checkPlotNumber);

}

export const elaboratorsPermissions = (value: any) => {
    if (!value) return false;
    return value.some((v: any) => {
        return isValidElaboratorPermission(v.uprawnienia);
    });
}

export const noSmallerThanCompared = (value: any, compared: number) => {
    return value !== '' && parseFloat(value) < compared;
}

export const noSmallerOrEqualThanCompared = (value: any, compared: number) => {
    return value !== '' && parseFloat(value) <= compared;
}

export const noBiggerThanCompared = (value: any, compared: number) => {
    return value !== '' && parseFloat(value) > compared;
}

export const noBiggerOrEqualThanCompared = (value: any, compared: number) => {
    return value !== '' && parseFloat(value) >= compared;
}

export const requiredOneOfTwo = (value: any, secondValue: any) => {
    return isEmpty(value) && isEmpty(secondValue);
}

const isEmpty = (value: any) => {
    return value === null || value === undefined || value === "";
}

const isValidElaboratorPermission = (value?: string) => {
    if (value === null && value === undefined && value === '') {
        return false;
    }
    return true;
    //return value?.startsWith('VI') || value?.startsWith('VII') || value?.startsWith('VIII');
}

//WWPPGG_R.XXXX.NDZ, NDZ to numer lub numer/numer
const checkPlotNumber = (value: string) => {
    //Zdjęta walidacja z pola SOPO-312
    return true;
    // eslint-disable-next-line no-unreachable
    const trimedValue = value.trim();
    let pattern = /\d{6}_\d+.\d+.(\d+|(\d+\/\d+))$/;
    return pattern.test(trimedValue);
}

const requiredDevelopments = (value: LandslideDevelopment[]) => {
    var creationRecs = value.filter(item => item.tyP_ZDARZENIA_SID === 1);
    return creationRecs.length === 0;
}

const checkFormula = (value: any, fConfig: any) => {
    var numValue = typeof (value) === 'string' ? Number(value) : value;
    return fConfig.hasParams === false || fConfig.calcValue === null || fConfig.calcValue !== numValue ? fConfig.msg : "";
}

const checkRoadAvailability = (value: number, compareValue: { roadCategories: LandslideRoadCategories[] | undefined, kolej: number | undefined },
    dictRoadCategory: Option[], dictCommInfra: Option[]) => {
    if (dictCommInfra.find(item => item.value === value && item.name?.toLowerCase().includes('kolej'))) return compareValue?.kolej !== 1;
    return compareValue?.roadCategories?.find(item => dictCommInfra.find(opt => opt.value === value)?.name?.toLowerCase().includes(dictRoadCategory?.find(elem => elem.value === item.kategoriA_DROGI_SID)?.name?.toLowerCase()!)) === undefined;
}

export enum inputStateType {
    inputError = "inputError",
    inputWarning = "inputWarning",
    inputValid = "inputValid",
    iconValid = "iconValid",
    searchWrapper = "searchWrapper"
}

export type configValidation = {
    required?: boolean,
    intType?: boolean,
    stringType?: boolean,
    identityType?: boolean,
    requiredArrayElement?: boolean,
    plotNumber?: boolean,
    elaboratorsRequired?: boolean,
    elaboratorsPermissions?: boolean,
    rocksRequired?: boolean,
    waterManifestationRequired?: boolean,
    landslideMonitoringRegistersRequired?: {
        hasMonitoring: boolean
    },
    publications?: boolean,
    rastersRequired?: boolean,
    coluvialMaterial?: boolean,
    landUseRequired?: boolean,
    developmentsRequired?: boolean,
    minCharacters?: {
        minNumberOfCharacters: number
    } & ValidationError,
    maxCharacters?: {
        maxNumberOfCharacters: number
    } & ValidationError,
    noLaterThanDateNow?: boolean,
    laterThan2020?: boolean,
    noLaterThan2020?: boolean,
    requiredText?: ValidationSubtext,
    forbiddenText?: ValidationSubtext,
    inRange?: ValidationRange,
    inRangeOrEmpty?: ValidationRange,
    noSmallerThan?: {
        minValue: number
    } & ValidationError,
    noSmallerThanDate?: {
        minValue: Date
    } & ValidationError,
    noBiggerThanDate?: {
        minValue: Date
    } & ValidationError,
    requiredFieldOfArrayElement?: ValidationRequired,
    requiredAnyFieldOfArrayElement?: ValidationRequired,
    noSmallerThanCompared?: ValidationCompare,
    noSmallerOrEqualThanCompared?: ValidationCompare,
    noSmallerThanComparedSecond?: ValidationCompare,
    noSmallerOrEqualThanComparedSecond?: ValidationCompare,
    noBiggerThanCompared?: ValidationCompare,
    noBiggerOrEqualThanCompared?: ValidationCompare,
    noBiggerThanComparedSecond?: ValidationCompare,
    requiredOneOfTwo?: {
        secondValue: any
    } & ValidationError,
    roadAvailibility?: {
        compareValue: {
            roadCategories: LandslideRoadCategories[] | undefined,
            kolej: number | undefined
        },
        dictRoadCategory: Option[],
        dictCommInfra: Option[]
    } & ValidationError,
    isMonitoring?: {
        hasData: boolean
    },
    formula?: {
        hasParams: boolean
        calcValue: any,
        msg: string
    }
}

type ValidationSubtext = {
    text: string
}

type ValidationCompare = {
    compareValue: number
} & ValidationError;

type ValidationRequired = {
    requireField: string
} & ValidationError;

type ValidationRange = {
    minRange: number,
    maxRange: number
} & ValidationError;

type ValidationError = {
    errorMsg: string
}

export const filterRasters = (form: krFormTypes, objectType: ObjectType, rasterType: string) => {
    if (objectType === ObjectType.KRO) {
        if (rasterType === "rastersElements1") {
            let data = (form as KrLandslideFormTypes)?.landslideRasters?.filter((raster: any) => {
                return (raster.details.rodzaj === "mapa_u" || raster.details.rodzaj === "szkic" || raster.details.rodzaj === "mapa_a")
            })
            return data;
        }
        if (rasterType === "rastersElements3") {
            let data = (form as KrLandslideFormTypes)?.landslideRasters?.filter((raster: any) => {
                return (raster.details.rodzaj === "foto")
            })
            return data;
        }
    }
    if (objectType === ObjectType.KRTZ) {

    }
}

export const createValidationKrForm = (krForm: krFormTypes, objectType: ObjectType, patternType: PatternType, dictionariesForValidation?: Dictionary) => {
    var validation: Record<string, configValidation> = {};
    attributesToValidation(validation, krForm, false, patternType, objectType);

    if (objectType === ObjectType.KRO) {
        let attributes = (krForm as KrLandslideFormTypes).landslideAttributes;
        validation["rastersElements1"] = createConfigValidation("rastersElements", false, filterRasters(krForm, objectType, "rastersElements1"), patternType, objectType);
        //validation["rastersElements2"] = createConfigValidation("rastersElements", false, undefined, patternType, objectType);
        validation["rastersElements3"] = createConfigValidation("rastersElements", false, filterRasters(krForm, objectType, "rastersElements3"), patternType, objectType);
        attributesToValidation(validation, attributes as object, false, patternType, objectType);
        validation["waterManifestation1"] = createConfigValidation("waterManifestation", false);
        validation["waterManifestation2"] = createConfigValidation("waterManifestation", false);
        validation["waterManifestation3"] = createConfigValidation("waterManifestation", false);
        validation["waterManifestation4"] = createConfigValidation("waterManifestation", false);

        var dictCommInfra = dictionariesForValidation !== undefined ? dictionariesForValidation["INFRASTRUKTURA_KOMUNIKACYJNA"] :
            krForm.dictionaries ? krForm.dictionaries["INFRASTRUKTURA_KOMUNIKACYJNA"] : null;
        if (dictCommInfra !== null) {
            var roadDamagesMaxLength = 5;
            var dictRoadCategory = dictionariesForValidation !== undefined ? dictionariesForValidation["KATEGORIA_DROGI"] :
                krForm.dictionaries ? krForm.dictionaries["KATEGORIA_DROGI"] : null;

            for (let i = 0; i < roadDamagesMaxLength; i++) {
                validation[`roadDamages${i}`] = createConfigValidation("roadDamages", false, { roadCategories: (krForm as KrLandslideFormTypes).roadCategories, kolej: (krForm as KrLandslideFormTypes).landslideAttributes?.kolej }, undefined, undefined,
                    [dictRoadCategory ? dictRoadCategory : [], dictCommInfra ? dictCommInfra : []]);
            }
        }

        validation["landUse"] = createConfigValidation("landUse", false);

        validation["kO_DLUGOSC"] = createConfigValidation("kO_DLUGOSC", false, attributes?.oS_DLUGOSC);
        validation["kO_MIAZSZOSC_SZAC"] = createConfigValidation("kO_MIAZSZOSC_SZAC", false, attributes?.kO_MIAZSZOSC_POM);
        validation["kO_MIAZSZOSC_POM"] = createConfigValidation("kO_MIAZSZOSC_POM", false, attributes?.kO_MIAZSZOSC_SZAC);

        validation["oS_DLUGOSC"] = createConfigValidation("oS_DLUGOSC", false, attributes?.kO_DLUGOSC);
        validation["oS_WYS_MAKS"] = createConfigValidation("oS_WYS_MAKS", false, attributes?.oS_WYS_MIN);
        validation["oS_WYS_MIN"] = createConfigValidation("oS_WYS_MIN", false, attributes?.oS_WYS_MAKS);

        if (patternType === PatternType.P2020) {
            validation["datA_USTALENIA"] = createConfigValidation("datA_USTALENIA", false, attributes?.datA_WYPELNIENIA, patternType)
            validation["datA_WYPELNIENIA"] = createConfigValidation("datA_WYPELNIENIA", false, attributes?.datA_USTALENIA, patternType)
        }

        validation["gmina"] = createConfigValidation("gmina", false, undefined, patternType, objectType);
        validation["powiat"] = createConfigValidation("powiat", false, undefined, patternType, objectType);
        validation["wojewodztwo"] = createConfigValidation("wojewodztwo", false, undefined, patternType, objectType);

        let monitoringValidation = createMonitoringValidation(krForm, objectType, patternType);
        validation["landslideMonitoringRegisters"] = monitoringValidation["landslideMonitoringRegisters"];
        validation["czY_MONITORING"] = monitoringValidation["czY_MONITORING"];
        validation["czY_MONITORING_POWIERZCHNIOWY"] = monitoringValidation["czY_MONITORING_POWIERZCHNIOWY"];
        validation["czY_MONITORING_WGLEBNY"] = monitoringValidation["czY_MONITORING_WGLEBNY"];

        validation["publications"] = {}

    } else if (objectType === ObjectType.KRTZ) {
        validation["rastersElements1"] = createConfigValidation("rastersElements", false, filterRasters(krForm, objectType, "rastersElements1"), patternType, objectType);
        attributesToValidation(validation, (krForm as KrEndangeredAreaFormTypes).endangeredAreaAttributes as object, false, patternType, objectType);
        if (patternType === PatternType.P2020) {
            validation["datA_USTALENIA"] = createConfigValidation("datA_USTALENIA", false, (krForm as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.datA_WYPELNIENIA, patternType)
            validation["datA_WYPELNIENIA"] = createConfigValidation("datA_WYPELNIENIA", false, (krForm as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.datA_USTALENIA, patternType)

            validation["gmina"] = createConfigValidation("gmina", false, undefined, patternType, objectType);
            validation["powiat"] = createConfigValidation("powiat", false, undefined, patternType, objectType);
            validation["wojewodztwo"] = createConfigValidation("wojewodztwo", false, undefined, patternType, objectType);
        }
    }

    if (objectType === ObjectType.KRTZ && patternType === PatternType.P2007) {
        validation["rastersElements1"] = {

        }
    }
    return validation;
}

export const createMonitoringValidation = (krForm: krFormTypes, objectType: ObjectType, patternType: PatternType) => {
    var validation: Record<string, configValidation> = {};

    let monitoringRegisters = (krForm as KrLandslideFormTypes).landslideMonitoringRegisters;
    let attributes = (krForm as KrLandslideFormTypes).landslideAttributes;
    if (patternType === PatternType.P2007) {
        validation["landslideMonitoringRegisters"] = createConfigValidation("landslideMonitoringRegisters", false, attributes?.czY_MONITORING === 1);

        let hasTableMonitoring = monitoringRegisters && monitoringRegisters?.length! > 0;
        validation["czY_MONITORING"] = createConfigValidation("czY_MONITORING", false, hasTableMonitoring, patternType, objectType);
    } else {
        let hasMonitoring = attributes?.czY_MONITORING_POWIERZCHNIOWY === 1 || attributes?.czY_MONITORING_WGLEBNY === 1;
        validation["landslideMonitoringRegisters"] = createConfigValidation("landslideMonitoringRegisters", false, hasMonitoring);

        let hasPow = monitoringTypeCheck(1, monitoringRegisters);
        validation["czY_MONITORING_POWIERZCHNIOWY"] = createConfigValidation("czY_MONITORING_POWIERZCHNIOWY", false, hasPow, patternType, objectType);
        let hasWgl = monitoringTypeCheck(2, monitoringRegisters);
        validation["czY_MONITORING_WGLEBNY"] = createConfigValidation("czY_MONITORING_WGLEBNY", false, hasWgl, patternType, objectType);
    }
    return validation;
}

export const createValidationKrFormWarnings = (krForm: krFormTypes, objectType: ObjectType, patternType: PatternType) => {
    var validationWarnings: Record<string, configValidation> = {};
    var attrs = (krForm as KrLandslideFormTypes).landslideAttributes;

    if (objectType === ObjectType.KRO && patternType === PatternType.P2007) {
        validationWarnings["sT_DLUGOSC"] = createConfigValidationWarnings("sT_DLUGOSC", false, attrs?.oS_DLUGOSC);
        validationWarnings["sT_WYSOKOSC"] = createConfigValidationWarnings("sT_WYSOKOSC", false, attrs?.oS_ROZPIETOSC);
    }
    validationWarnings["sG_WYSOKOSC"] = createConfigValidationWarnings("sG_WYSOKOSC");
    validationWarnings["sG_NACHYLENIE"] = createConfigValidationWarnings("sG_NACHYLENIE", false, attrs?.oS_NACHYLENIE, undefined, undefined, attrs?.kO_NACHYLENIE);
    validationWarnings["kO_NACHYLENIE"] = createConfigValidationWarnings("kO_NACHYLENIE", false, attrs?.oS_NACHYLENIE);
    validationWarnings["kO_MIAZSZOSC_SZAC"] = createConfigValidationWarnings("kO_MIAZSZOSC_SZAC", false, attrs?.kO_WYS_CZOLA);
    validationWarnings["kO_MIAZSZOSC_POM"] = createConfigValidationWarnings("kO_MIAZSZOSC_POM", false, attrs?.kO_WYS_CZOLA);
    validationWarnings["kO_WYS_CZOLA"] = createConfigValidationWarnings("kO_WYS_CZOLA", false, attrs?.kO_MIAZSZOSC_SZAC, undefined, undefined, attrs?.kO_MIAZSZOSC_POM);

    //prepare formulas
    if (attrs) {
        const koD = CalcField.koDlugosc(attrs);
        const koDP = CalcField.hasKoDlugoscParams(attrs);
        validationWarnings["kO_DLUGOSC"] = toFormulaConfig(koDP, koD, FormulaMsg.KoD);
        const koN = CalcField.koNachylenie(attrs);
        const koNP = CalcField.hasKoNachylenieParams(attrs);
        validationWarnings["kO_NACHYLENIE"].formula = toFormulaConfig(koNP, koN, FormulaMsg.KoN).formula;
        const osR = CalcField.osRozpietosc(attrs);
        const osRP = CalcField.hasOsRozpietoscParams(attrs);
        validationWarnings["oS_ROZPIETOSC"] = toFormulaConfig(osRP, osR, FormulaMsg.OsR);
        if (objectType === ObjectType.KRO && patternType === PatternType.P2007) {
            const stN = CalcField.stNachylenie(attrs);
            const stNP = CalcField.hasStNachylenieParams(attrs);
            validationWarnings["sT_NACHYLENIE"] = toFormulaConfig(stNP, stN, FormulaMsg.StN);
        }
    }

    return validationWarnings;
}

export const toFormulaConfig = (hasParams: boolean, calcValue: any, msg: string) => {
    var config: configValidation = {};
    config.formula = {
        hasParams: hasParams,
        calcValue: calcValue,
        msg: msg
    }
    return config;
}

export const createValidationPoForm = (poForm: poFormTypes) => {
    var validation: Record<string, configValidation> = {};
    attributesToValidation(validation, poForm.protocolAttributes!, true);
    attributesToValidation(validation, poForm, true);
    validation["datA_PROT"] = createConfigValidation("datA_PROT", true, (poForm as poFormTypes).protocolAttributes?.datA_OBS);
    return validation;
}

const attributesToValidation = (validation: Record<string, configValidation>, attributes: object, isPO?: boolean, patternType?: PatternType, objectType?: ObjectType) => {
    for (const key of Object.keys(attributes!)) {
        validation[key] = createConfigValidation(key, isPO, undefined, patternType, objectType);
    }
}

export const createConfigValidationWarnings = (name: string, isPO?: boolean, comparedValue?: any, patternType?: PatternType, objectType?: ObjectType, comparedValueSecond?: any) => {
    var config: configValidation = {};
    switch (name) {
        case "sT_DLUGOSC":
            config.noSmallerThan = {
                minValue: comparedValue,
                errorMsg: "Wartość mniejsza niż wskazana długość osuwiska"
            }
            break;
        case "sT_WYSOKOSC":
            config.noSmallerThan = {
                minValue: comparedValue,
                errorMsg: "Wartość mniejsza niż wskazana rozpiętość pionowa"
            }
            break;
        case "sG_WYSOKOSC":
            config.inRange = {
                minRange: 0,
                maxRange: 100,
                errorMsg: "Zakres wykracza poza 0-100"
            }
            break;
        case "sG_NACHYLENIE":
            config.noSmallerThanCompared = {
                compareValue: comparedValue,
                errorMsg: "Wartość nie może być mniejsza od nachylenia ogólnego"
            };
            config.noSmallerThanComparedSecond = {
                compareValue: comparedValueSecond,
                errorMsg: "Wartość nie może być mniejsza od nachylenia koluwium"
            }
            break;
        case "kO_NACHYLENIE":
            config.noBiggerThanCompared = {
                compareValue: comparedValue,
                errorMsg: "Wartość nie może być większa od nachylenia ogólnego"
            }
            break;
        case "kO_MIAZSZOSC_POM":
        case "kO_MIAZSZOSC_SZAC":
            config.noSmallerThanCompared = {
                compareValue: comparedValue,
                errorMsg: "Wartość nie może być mniejsza od wysokości czoła"
            }
            break;
        case "kO_WYS_CZOLA":
            config.inRange = {
                minRange: 0,
                maxRange: 100,
                errorMsg: "Wartość wykracza poza zakres 0-100"
            }
            config.noBiggerThanCompared = {
                compareValue: comparedValue,
                errorMsg: "Wartość nie może być większa niż miąższość szacowana lub mierzona"
            }
            config.noBiggerThanComparedSecond = {
                compareValue: comparedValueSecond,
                errorMsg: "Wartość nie może być większa niż miąższość szacowana lub mierzona"
            }
            break;
        case "":
    }
    return config;
}

export const createConfigValidation = (name: string, isPO?: boolean, comparedValue?: any, patternType?: PatternType, objectType?: ObjectType, helperDicts?: Option[][]) => {
    var config: configValidation = {};
    if (isPO) {
        switch (name) {
            case "onlyRequired":
            case "obiekT_NUMER_IDENTYFIKACYJNY":
                config.required = true;
                break;
            case "elaborators":
                config.elaboratorsRequired = true;
                break;
            case "wnioski":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 10,
                    errorMsg: "Należy wpisać minimum 10 znaków"
                }
                break;
            case "zalecenia":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 20,
                    errorMsg: "Należy wpisać minimum 20 znaków"
                }
                break;
            case "datA_OBS":
                config.required = true;
                config.noLaterThanDateNow = true;
                break;
            case "datA_PROT":
                config.required = true;
                config.noLaterThanDateNow = true;
                config.noSmallerThanDate = {
                    minValue: comparedValue,
                    errorMsg: "Data nie może być mniejsza niż data obserwacji"
                }
                break;
            case "rasters":
                config.requiredFieldOfArrayElement = {
                    requireField: "opis",
                    errorMsg: "Należy dodać opis pliku"
                }
                break;
        }
    }
    else {
        if (patternType === PatternType.P2007) {
            switch (name) {
                case "datA_WYPELNIENIA":
                    config.required = true;
                    config.noLaterThanDateNow = true;
                    config.laterThan2020 = true;
                    break;
            }
            if (objectType === ObjectType.KRO) {
                switch (name) {
                    case "grS80_DLUGOSC":
                    case "grS80_SZEROKOSC":
                    case "miejscowosC_NAZWA":
                    case "gmina":
                    case "powiat":
                    case "wojewodztwo":
                    case "tyP_STOKU_SID":
                    case "kieruneK_EKSPOZYCJI_SID":
                    case "sT_NACHYLENIE":
                        config.required = true;
                        break;
                    case "numerY_DZIALEK":
                        config.plotNumber = true;
                        break;
                    case "oS_AZYMUT":
                        config.required = true;
                        config.inRange = {
                            minRange: 0,
                            maxRange: 359,
                            errorMsg: "Należy wpisać wartość z zakresu od 0 do 359"
                        }
                        config.intType = true;
                        break;
                    case "sT_DLUGOSC":
                        config.required = true;
                        config.inRange = {
                            minRange: 1,
                            maxRange: 5000,
                            errorMsg: "Należy wpisać wartość z zakresu 1-5000"
                        }
                        break;
                    case "sT_WYSOKOSC":
                        config.required = true;
                        config.inRange = {
                            minRange: 1,
                            maxRange: 2000,
                            errorMsg: "Należy wpisać wartość z zakresu 1-2000"
                        }
                        break;
                    case "czY_MONITORING":
                        config.isMonitoring = {
                            hasData: comparedValue
                        }
                }
            }
        } else {
            switch (name) {
                case "pL1992_X":
                case "pL1992_Y":
                case "miejscowosC_NAZWA":
                case "gmina":
                case "powiat":
                case "wojewodztwo":
                    config.required = true;
                    break;
                case "datA_USTALENIA":
                    config.required = true;
                    config.noLaterThanDateNow = true;
                    config.noBiggerThanDate = {
                        minValue: comparedValue,
                        errorMsg: "Data ustalenia nie może być większa niż data wypełnienia karty."
                    }
                    break;
                case "datA_WYPELNIENIA":
                    config.required = true;
                    config.noLaterThanDateNow = true;
                    config.noSmallerThanDate = {
                        minValue: comparedValue,
                        errorMsg: "Data wypełnienia nie może być mniejsza niż data ustalenia."
                    }
                    config.noLaterThan2020 = true;
                    break;
                case "numerY_DZIALEK":
                    config.plotNumber = true;
                    break;
                case "czY_MONITORING_POWIERZCHNIOWY":
                    config.isMonitoring = {
                        hasData: comparedValue
                    }
                    break;
                case "czY_MONITORING_WGLEBNY":
                    config.isMonitoring = {
                        hasData: comparedValue
                    }
                    break;
                case "":
            }
        }
        //common fields
        switch (name) {
            case "onlyRequired":
            case "sheets":
            case "sMGP50Ks":
            case "geographicalLands":
            case "tectonicUnits":
            case "zlewnia":
            case "numeR_IDENTYFIKACYJNY":
            case "godlo10k":
            case "smgp50k":
            case "wskazania":
            case "sytuacjA_GEOMORFOLOGICZNA_SID":
            case "rodzaJ_MATERIALU_SID":
            case "rodzaJ_RUCHU_SID":
            case "uklaD_GEOLOGICZNY_SID":
            case "oS_POWIERZCHNIA":
            case "oS_ROZPIETOSC":
            case "kO_WYS_CZOLA":
            case "sG_SZCZELINY":
            case "sG_SKARPY_WTORNE":
            case "uT_ZAB_INNA":
            case "tectonics":
            case "monitorinG_WSKAZ_WIZJI":
            case "monitorinG_WSKAZ_MON":
                config.required = true;
                break;
            case "uT_ZAB_MIESZKALNA":
            case "uT_ZAB_GOSPODARCZA":
            case "uT_ZAB_PRZEM_USLUG":
            case "uT_ZAB_UZYT_PUBL":
            case "uT_ZAB_ZABYT_SAKR":
                config.required = true;
                config.noSmallerThan = {
                    minValue: 0,
                    errorMsg: 'Wartość nie może być mniejsza niż 0'
                };
                break;
            case "zabezpieczeniE_OPIS":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 12,
                    errorMsg: "Należy wpisać minimum 12 znaków"
                }
                break;
            case "LandslideRasters":
                config.requiredFieldOfArrayElement = {
                    requireField: "opis",
                    errorMsg: "Należy dodać opis pliku"
                }
                break;
            case "designationCriteria":
                config.requiredArrayElement = true;
                config.requiredAnyFieldOfArrayElement = {
                    requireField: "uzasadnienie",
                    errorMsg: "Co najmniej jedno z pól musi posiadać wpisane uzasadnienie przyczyny."
                }
                break;
            case "elaborators":
                config.elaboratorsRequired = true;
                config.elaboratorsPermissions = true;
                break;
            case "rocks":
                config.rocksRequired = true;
                break;
            case "developments":
                config.developmentsRequired = true;
                break;
            case "koluvia":
                config.coluvialMaterial = true;
                break;
            case "landUse":
                config.landUseRequired = true;
                break;
            case "waterManifestation":
                config.waterManifestationRequired = true;
                break;
            case "landslideMonitoringRegisters":
                config.landslideMonitoringRegistersRequired = {
                    hasMonitoring: comparedValue
                };
                break;
            case "publications":
                config.publications = true;
                break;
            case "rastersElements":
                config.rastersRequired = true;
                break;
            case "charakterystykA_OPIS":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 17,
                    errorMsg: "Należy wpisać minimum 17 znaków"
                };
                config.requiredText = {
                    text: "aktywn"
                };
                config.forbiddenText = {
                    text: "//"
                }
                break;
            case "oS_SZEROKOSC":
                config.required = true;
                config.noSmallerThan = {
                    minValue: 1,
                    errorMsg: 'Wartość nie może być mniejsza niż 1'
                }
                break;
            case "oS_DLUGOSC":
                config.required = true;
                config.noSmallerThan = {
                    minValue: 1,
                    errorMsg: 'Wartość nie może być mniejsza niż 1'
                };
                config.noSmallerThanCompared = {
                    compareValue: comparedValue,
                    errorMsg: 'Długość nie może być mniejsza niż długość koluwium'
                }
                break;
            case "oS_WYS_MAKS":
                config.required = true;
                config.inRange = {
                    minRange: -2,
                    maxRange: 2500,
                    errorMsg: "Należy wpisać wartość z zakresu od -2 do 2500"
                }
                config.noSmallerOrEqualThanCompared = {
                    compareValue: comparedValue,
                    errorMsg: "Wartość musi być większa niż wysokość minimalna"
                }
                config.intType = true;
                break;
            case "oS_WYS_MIN":
                config.required = true;
                config.inRange = {
                    minRange: -2,
                    maxRange: 2500,
                    errorMsg: "Należy wpisać wartość z zakresu od -2 do 2500"
                }
                config.noBiggerOrEqualThanCompared = {
                    compareValue: comparedValue,
                    errorMsg: "Wartość musi być mniejsza niż wysokość maksymalna"
                }
                config.intType = true;
                break;
            case "oS_NACHYLENIE":
                config.required = true;
                config.inRange = {
                    minRange: 1,
                    maxRange: 90,
                    errorMsg: "Należy wpisać wartość z zakresu od 1 do 90"
                }
                break;
            case "sG_WYSOKOSC":
                config.required = true;
                config.inRange = {
                    minRange: 0,
                    maxRange: 2000,
                    errorMsg: "Należy wpisać wartość z zakresu od 0 do 2000"
                }
                break;
            case "sG_NACHYLENIE":
            case "kO_NACHYLENIE":
                config.required = true;
                config.inRange = {
                    minRange: 0,
                    maxRange: 90,
                    errorMsg: "Należy wpisać wartość z zakresu od 0 do 90"
                }
                break;
            case "uwagi":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 20,
                    errorMsg: "Należy wpisać minimum 20 znaków"
                }
                break;
            case "dalszE_RUCHY":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 20,
                    errorMsg: "Należy wpisać minimum 20 znaków"
                }
                break;
            case "kO_MIAZSZOSC_SZAC":
                config.inRangeOrEmpty = {
                    minRange: 1,
                    maxRange: 300,
                    errorMsg: "Należy wpisać wartość z zakresu od 1 do 300"
                }
                config.requiredOneOfTwo = {
                    secondValue: comparedValue,
                    errorMsg: "Wymagane podanie wartości mierzonej albo szacowanej"
                }
                config.noSmallerThanCompared = {
                    compareValue: comparedValue,
                    errorMsg: "Wartość miąższości szacowanej nie może być mniejsza od mierzonej"
                }
                break;
            case "kO_MIAZSZOSC_POM":
                config.inRangeOrEmpty = {
                    minRange: 1,
                    maxRange: 300,
                    errorMsg: "Należy wpisać wartość z zakresu od 1 do 300"
                }
                config.requiredOneOfTwo = {
                    secondValue: comparedValue,
                    errorMsg: "Wymagane podanie wartości mierzonej albo szacowanej"
                }
                config.noBiggerThanCompared = {
                    compareValue: comparedValue,
                    errorMsg: "Wartość miąższości mierzonej nie może być większa od szacowanej"
                }
                break;
            case "wydawnictwO_NAZWA":
                config.requiredOneOfTwo = {
                    secondValue: comparedValue,
                    errorMsg: "Wymagane podanie nazwy czasopisma albo nazwy wydawnictwa"
                }
                break;
            case "czasopismO_NAZWA":
                config.requiredOneOfTwo = {
                    secondValue: comparedValue,
                    errorMsg: "Wymagane podanie nazwy czasopisma albo nazwy wydawnictwa"
                }
                break;
            case "czasopismO_OZNACZENIE":
                if (comparedValue != null && comparedValue !== undefined && comparedValue !== "") {
                    config.required = true;
                }
                break;
            case "Azimuths":
                config.required = true;
                config.inRange = {
                    minRange: 0,
                    maxRange: 359,
                    errorMsg: "Należy wpisać wartość z zakresu od 0 do 359"
                }
                break;
            case "Upad":
                config.required = true;
                config.inRange = {
                    minRange: 1,
                    maxRange: 90,
                    errorMsg: "Należy wpisać wartość z zakresu od 1 do 90"
                }
                break;
            case "kO_DLUGOSC":
                config.required = true;
                config.inRange = {
                    minRange: 1,
                    maxRange: 5000,
                    errorMsg: "Należy wpisać wartość z zakresu od 1 do 5000"
                }
                config.noBiggerThanCompared = {
                    compareValue: comparedValue,
                    errorMsg: "Wartość nie może być większa niż długość ogólna"
                }
                break;
            case "stopieN_AKTYWNOSCI":
                config.required = true;
                config.minCharacters = {
                    minNumberOfCharacters: 10,
                    errorMsg: "Należy wpisać minimum 10 znaków"
                };
                break;
            case "roadDamages":
                config.roadAvailibility = {
                    compareValue: comparedValue,
                    errorMsg: "Nie można wybrać tego rodzaju infrastruktury",
                    dictRoadCategory: helperDicts ? helperDicts[0] : [],
                    dictCommInfra: helperDicts ? helperDicts[1] : []
                };
                break;
            case "szkodY_ZABUDOWA_OPIS":
                if (comparedValue != null && comparedValue !== undefined && comparedValue.length === 0) {
                    config.required = true;
                }
                break;
            case "szkodY_KOMUNIKACJA_OPIS":
                if (comparedValue != null && comparedValue !== undefined && comparedValue.length === 0) {
                    config.required = true;
                }
                break;
            case "dokumenty_Tytul":
                config.required = true;
                config.maxCharacters = {
                    maxNumberOfCharacters: 250,
                    errorMsg: "Należy wpisać maksymalnie 250 znaków"
                }
                break;
            case "":
        }
    }
    return config;
}

export const validationErrorsKrFormWarnings = (krForm: krFormTypes, objectType: ObjectType, patternType: PatternType): krFormTypes => {
    var ValidationErrors: Record<string, string> = {};
    if (!krForm?.config?.ValidationWarnings) { return krForm; };

    if (objectType === ObjectType.KRO) {
        const attrs = (krForm as KrLandslideFormTypes)?.landslideAttributes;
        for (const key of Object.keys(attrs!)) {
            if (attrs) {
                ValidationErrors[key] = validation(krForm.config?.ValidationWarnings[key], attrs[key as keyof landSlideAttributes]);
            }
        }
    } else {
        const endangeredAreaAttributes = (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes;
        for (const key of Object.keys(endangeredAreaAttributes!)) {
            if (endangeredAreaAttributes) {
                ValidationErrors[key] = validation(krForm.config?.ValidationWarnings[key], endangeredAreaAttributes[key as keyof endangeredAreaAttributes]);
            }
        }
    }

    for (const key of Object.keys(krForm)) {
        ValidationErrors[key] = validation(krForm?.config?.ValidationWarnings[key], krForm[key as keyof krFormTypes]);
    }
    return _assignWarningsToConfig(krForm, ValidationErrors);
}

const getGminy = (krForm: krFormTypes, objectType: ObjectType) => {
    var objGminy = (objectType === ObjectType.KRO) ? (krForm as KrLandslideFormTypes).landslideGminy : (krForm as KrEndangeredAreaFormTypes).endangeredAreaGminy;
    var gminy: any[] | undefined = objGminy?.map(item => item);
    return gminy;
}

export const hasRelatedGmina = (krForm: krFormTypes, objectType: ObjectType, miejscowosciDic?: Dictionary) => {
    let hasRelated = false;
    let mDic = miejscowosciDic !== undefined ? miejscowosciDic["MIEJSCOWOSCI"] : krForm.dictionaries ? krForm.dictionaries["MIEJSCOWOSCI"] : null;
    if (mDic && mDic.length > 0) {
        const miejscowoscGid = (objectType === ObjectType.KRO) ?
            (krForm as KrLandslideFormTypes)?.landslideAttributes?.miejscowosC_GID :
            (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes?.miejscowosC_GID;
        var selectedMiejscowosc = mDic.find(d => d.anothers?.GLOBALID === miejscowoscGid);
        if (selectedMiejscowosc !== undefined) {
            var gid = selectedMiejscowosc.anothers.GMI_ID;
            var objGminy = getGminy(krForm, objectType);
            if (objGminy && objGminy.length > 0) {
                var gmina = objGminy!.find((elem: any) => elem.gminA_ID === gid && elem.gminA_ID !== null);
                if (gmina) { hasRelated = true; }
            }
        }
    }
    return hasRelated;
}

const prepareDictOptions = (dict: Option[], fillDate: number, value: number | null | undefined) => {
    if (dict) {
        let option = dict.find((optionDict) => {
            if (optionDict.anothers && optionDict.value && (optionDict.anothers.WAZNY_OD || optionDict.anothers.WAZNY_DO)) {
                return optionDict.value === value;
            }
            return undefined;
        })
        if (option) {
            if (option.anothers && (option.anothers.WAZNY_OD || option.anothers.WAZNY_DO)) {
                if (option.anothers.WAZNY_OD && fillDate < option.anothers.WAZNY_OD) {
                    return true
                }
                if (option.anothers.WAZNY_DO && fillDate > option.anothers.WAZNY_DO) {
                    return true
                }
            }
        }
    }
    return false;
}

const getOpt = (dict: Option[], value: any) => {
    if (value) {
        return dict.find((optionDict) => {
            return optionDict.value === value
        })?.name;
    }
}

const prepareDateCheckDictValidation = (objectType: ObjectType, dictionaries?: Dictionary, krForm?: krFormTypes, ValidationErrors?: Record<string, string>) => {
    let fillDate: number = objectType === ObjectType.KRO ? (krForm as KrLandslideFormTypes).landslideAttributes?.datA_WYPELNIENIA :
        (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes?.datA_WYPELNIENIA
    if (dictionaries && krForm && ValidationErrors && fillDate) {
        for (const key of Object.keys(dictionaries)) {
            let dict = dictionaries[key];
            if (dict) {
                switch (key) {
                    case "KATEGORIA_DROGI":
                        (krForm as KrLandslideFormTypes).roadCategories?.forEach((road) => {
                            if (road.kategoriA_DROGI_SID && prepareDictOptions(dict, fillDate, road.kategoriA_DROGI_SID!)) {
                                ValidationErrors["roads"] = `Wartość o nazwie ${getOpt(dict, road.kategoriA_DROGI_SID)} ze słownika Kategoria drogi nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "KIERUNEK_EKSPOZYCJI_SID":
                        let kierunekEkspozycji = (krForm as KrLandslideFormTypes).landslideAttributes?.kieruneK_EKSPOZYCJI_SID
                        if (kierunekEkspozycji && prepareDictOptions(dict, fillDate, kierunekEkspozycji)) {
                            ValidationErrors["kieruneK_EKSPOZYCJI_SID"] = `Wartość o nazwie ${getOpt(dict, kierunekEkspozycji)} ze słownika kierunek ekspozycji nie jest odpowiednia dla daty wypełnienia`
                        }
                        break;
                    case "KRYT_WYZN_TZ_GLOWNE_ID":
                        (krForm as KrEndangeredAreaFormTypes)?.designationCriteria?.forEach((designation) => {
                            if (designation.kryT_WYZN_TZ_GLOWNE_ID && prepareDictOptions(dict, fillDate, designation.kryT_WYZN_TZ_GLOWNE_ID!)) {
                                ValidationErrors["designationCriteria"] = `Wartość o nazwie ${getOpt(dict, designation.kryT_WYZN_TZ_GLOWNE_ID)} ze słownika kryterium główne nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "DICT_KRYT_WYZN_TZ_SZCZEGOLOWE":
                        (krForm as KrEndangeredAreaFormTypes)?.designationCriteria?.forEach((designation) => {
                            if (designation.kryT_WYZN_TZ_SZCZEGOLOWE_ID && prepareDictOptions(dict, fillDate, designation.kryT_WYZN_TZ_SZCZEGOLOWE_ID!)) {
                                ValidationErrors["designationCriteria"] = `Wartość o nazwie ${getOpt(dict, designation.kryT_WYZN_TZ_SZCZEGOLOWE_ID)} ze słownika kryterium szczegółowe nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "PORA_ROKU_SID":
                        (krForm as KrLandslideFormTypes)?.developments?.forEach((development) => {
                            if (development.porA_ROKU_DO_SID && prepareDictOptions(dict, fillDate, development.porA_ROKU_DO_SID!)) {
                                ValidationErrors["developments"] = `Wartość o nazwie ${getOpt(dict, development.porA_ROKU_DO_SID)} ze słownika pora roku nie jest odpowiednia dla daty wypełnienia`
                            }
                            if (development.porA_ROKU_SID && prepareDictOptions(dict, fillDate, development.porA_ROKU_SID!)) {
                                ValidationErrors["developments"] = `Wartość o nazwie ${getOpt(dict, development.porA_ROKU_SID)} ze słownika pora roku nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "PRZYCZYNA_RUCHU_SID":
                        (krForm as KrLandslideFormTypes)?.movementCause?.forEach((movement) => {
                            if (movement.przyczynA_RUCHU_SID && prepareDictOptions(dict, fillDate, movement.przyczynA_RUCHU_SID!)) {
                                if (ValidationErrors["developments"] && ValidationErrors["developments"] !== '') {
                                    ValidationErrors["developments"] = `. Wartość o nazwie ${getOpt(dict, movement.przyczynA_RUCHU_SID)} ze słownika przyczyna ruchu nie jest odpowiednia dla daty wypełnienia`
                                }
                                else {
                                    ValidationErrors["developments"] = `Wartość o nazwie ${getOpt(dict, movement.przyczynA_RUCHU_SID)} ze słownika przyczyna ruchu nie jest odpowiednia dla daty wypełnienia`
                                }
                            }
                        })
                        break;
                    case "RODZAJ_KOLUWIUM_SID":
                        (krForm as KrLandslideFormTypes)?.koluvia?.forEach((koluvium) => {
                            if (koluvium.rodzaJ_KOLUWIUM_SID && prepareDictOptions(dict, fillDate, koluvium.rodzaJ_KOLUWIUM_SID!)) {
                                ValidationErrors["koluvia"] = `Wartość o nazwie ${getOpt(dict, koluvium.rodzaJ_KOLUWIUM_SID)} ze słownika rodzaj koluwium nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "RODZAJ_MATERIALU_SID":
                        let rodzajMaterialu = (krForm as KrLandslideFormTypes).landslideAttributes?.rodzaJ_MATERIALU_SID
                        if (rodzajMaterialu && prepareDictOptions(dict, fillDate, rodzajMaterialu)) {
                            ValidationErrors["rodzaJ_MATERIALU_SID"] = `Wartość o nazwie ${getOpt(dict, rodzajMaterialu)} ze słownika rodzaj materiału nie jest odpowiednia dla daty wypełnienia`
                        }
                        break;
                    case "RODZAJ_MONITORINGU_SID":
                        (krForm as KrLandslideFormTypes)?.landslideMonitoringRegisters?.forEach((monitoringRegisters) => {
                            if (monitoringRegisters.rodzaJ_MONITORINGU_SID && prepareDictOptions(dict, fillDate, monitoringRegisters.rodzaJ_MONITORINGU_SID!)) {
                                ValidationErrors["landslideMonitoringRegisters"] = `Wartość o nazwie ${getOpt(dict, monitoringRegisters.rodzaJ_MONITORINGU_SID)} ze słownika rodzaj monitoringu nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "RODZAJ_OKRESU_CZASU_SID":
                        (krForm as KrLandslideFormTypes)?.developments?.forEach((development) => {
                            if (development.rodzaJ_OKRESU_CZASU_SID && prepareDictOptions(dict, fillDate, development.rodzaJ_OKRESU_CZASU_SID!)) {
                                ValidationErrors["developments"] = `Wartość o nazwie ${getOpt(dict, development.rodzaJ_OKRESU_CZASU_SID)} ze słownika rodzaj okresu czasu nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "RODZAJ_RUCHU_SID":
                        let rodzajRuchu = (krForm as KrLandslideFormTypes).landslideAttributes?.rodzaJ_RUCHU_SID
                        if (rodzajRuchu && prepareDictOptions(dict, fillDate, rodzajRuchu)) {
                            ValidationErrors["rodzaJ_RUCHU_SID"] = `Wartość o nazwie ${getOpt(dict, rodzajRuchu)} ze słownika rodzaj ruchu nie jest odpowiednia dla daty wypełnienia`
                        }
                        break;
                    case "RODZAJ_TEKTONIKI_SID":
                        (krForm as KrLandslideFormTypes)?.tectonics?.forEach((tectonic) => {
                            if (tectonic.rodzaJ_TEKTONIKI_SID && prepareDictOptions(dict, fillDate, tectonic.rodzaJ_TEKTONIKI_SID!)) {
                                ValidationErrors["tectonics"] = `Wartość o nazwie ${getOpt(dict, tectonic.rodzaJ_TEKTONIKI_SID)} ze słownika rodzaj tektoniki nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "RODZAJ_ZALEGANIA_SKALY_SID":
                        (krForm as KrLandslideFormTypes)?.rockDeposits?.forEach((rockDeposit) => {
                            if (rockDeposit.rodzaJ_ZALEGANIA_SKALY_SID && prepareDictOptions(dict, fillDate, rockDeposit.rodzaJ_ZALEGANIA_SKALY_SID!)) {
                                ValidationErrors["rocks"] = `Wartość o nazwie ${getOpt(dict, rockDeposit.rodzaJ_ZALEGANIA_SKALY_SID)} ze słownika rodzaj zalegania skały nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "SYTUACJA_GEOMORFOLOGICZNA_SID":
                        let geomorfologiczna = (krForm as KrLandslideFormTypes).landslideAttributes?.sytuacjA_GEOMORFOLOGICZNA_SID
                        if (geomorfologiczna && prepareDictOptions(dict, fillDate, geomorfologiczna)) {
                            ValidationErrors["sytuacjA_GEOMORFOLOGICZNA_SID"] = `Wartość o nazwie ${getOpt(dict, geomorfologiczna)} ze słownika sytuacja geomorfologiczna nie jest odpowiednia dla daty wypełnienia`
                        }
                        break;
                    case "TYP_PRZEJAWU_SID":
                        {
                            (krForm as KrLandslideFormTypes)?.waters?.filter((wat) => { return wat.tyP_STREFY_SID === 1 })?.forEach((water) => {
                                if (water.tyP_PRZEJAWU_SID && prepareDictOptions(dict, fillDate, water.tyP_PRZEJAWU_SID!)) {
                                    ValidationErrors["waterManifestation1"] = `Wartość o nazwie ${getOpt(dict, water.tyP_PRZEJAWU_SID)} ze słownika typ przejawu wód nie jest odpowiednia dla daty wypełnienia`
                                }
                            });
                            (krForm as KrLandslideFormTypes)?.waters?.filter((wat) => { return wat.tyP_STREFY_SID === 2 })?.forEach((water) => {
                                if (water.tyP_PRZEJAWU_SID && prepareDictOptions(dict, fillDate, water.tyP_PRZEJAWU_SID!)) {
                                    ValidationErrors["waterManifestation2"] = `Wartość o nazwie ${getOpt(dict, water.tyP_PRZEJAWU_SID)} ze słownika typ przejawu wód nie jest odpowiednia dla daty wypełnienia`
                                }
                            });
                            (krForm as KrLandslideFormTypes)?.waters?.filter((wat) => { return wat.tyP_STREFY_SID === 3 })?.forEach((water) => {
                                if (water.tyP_PRZEJAWU_SID && prepareDictOptions(dict, fillDate, water.tyP_PRZEJAWU_SID!)) {
                                    ValidationErrors["waterManifestation3"] = `Wartość o nazwie ${getOpt(dict, water.tyP_PRZEJAWU_SID)} ze słownika typ przejawu wód nie jest odpowiednia dla daty wypełnienia`
                                }
                            });
                            (krForm as KrLandslideFormTypes)?.waters?.filter((wat) => { return wat.tyP_STREFY_SID === 4 })?.forEach((water) => {
                                if (water.tyP_PRZEJAWU_SID && prepareDictOptions(dict, fillDate, water.tyP_PRZEJAWU_SID!)) {
                                    ValidationErrors["waterManifestation4"] = `Wartość o nazwie ${getOpt(dict, water.tyP_PRZEJAWU_SID)} ze słownika typ przejawu wód nie jest odpowiednia dla daty wypełnienia`
                                }
                            });
                            break;
                        }
                    case "TYP_STOKU_SID":
                        let stok = (krForm as KrLandslideFormTypes).landslideAttributes?.tyP_STOKU_SID
                        if (stok && prepareDictOptions(dict, fillDate, stok)) {
                            ValidationErrors["tyP_STOKU_SID"] = `Wartość o nazwie ${getOpt(dict, stok)} ze słownika typ stoku nie jest odpowiednia dla daty wypełnienia`
                        }
                        break;
                    case "TYP_ZDARZENIA_SID":
                        (krForm as KrLandslideFormTypes)?.developments?.forEach((development) => {
                            if (development.tyP_ZDARZENIA_SID && prepareDictOptions(dict, fillDate, development.tyP_ZDARZENIA_SID!)) {
                                ValidationErrors["developments"] = `Wartość o nazwie ${getOpt(dict, development.tyP_ZDARZENIA_SID)} ze słownika typ zdarzenia nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                    case "UKLAD_GEOLOGICZNY_SID":
                        let uklad = (krForm as KrLandslideFormTypes).landslideAttributes?.uklaD_GEOLOGICZNY_SID
                        if (uklad && prepareDictOptions(dict, fillDate, uklad)) {
                            ValidationErrors["uklaD_GEOLOGICZNY_SID"] = `Wartość o nazwie ${getOpt(dict, uklad)} ze słownika typ stoku nie jest odpowiednia dla daty wypełnienia`
                        }
                        break;
                    case "INFRASTRUKTURA_KOMUNIKACYJNA":
                        (krForm as KrLandslideFormTypes)?.landslideRoadDamages?.forEach((roadDamage, idx) => {
                            if (roadDamage.infrastrukturA_KOM_SID && prepareDictOptions(dict, fillDate, roadDamage.infrastrukturA_KOM_SID!)) {
                                ValidationErrors["infrastrukturA_KOM_SID"] = `Wartość o nazwie ${getOpt(dict, roadDamage.infrastrukturA_KOM_SID)} ze słownika infrastruktura komunikacyjna nie jest odpowiednia dla daty wypełnienia`
                            }
                        })
                        break;
                }
            }
        }
    }

}

export const validationErrorsKrForm = (krForm: krFormTypes, objectType: ObjectType, patternType: PatternType, isAutomaticValidation?: boolean, dictionariesForValidation?: Dictionary): krFormTypes => {
    var ValidationErrors: Record<string, string> = {};
    if (!krForm?.config?.Validation) { return krForm; };

    for (const key of Object.keys(krForm)) {
        ValidationErrors[key] = validation(krForm?.config?.Validation[key], krForm[key as keyof krFormTypes]);
    }

    if ((objectType === ObjectType.KRTZ && patternType === PatternType.P2007) === false) {
        var gmina = "";
        var powiat = "";
        var wojewodztwo = "";
        const createFieldsForLocation = () => {
            const gminy = objectType === ObjectType.KRO ? (krForm as KrLandslideFormTypes)?.landslideGminy : (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaGminy;
            _createFieldsForLocation(gminy);
        }

        const _createFieldsForLocation = (gminy?: LandslideGminyAttributes[] | EndangeredAreaGminyAttributes[] | undefined) => {
            if (gminy && gminy.length > 0) {
                let first = gminy[0];
                gmina = first.gmina ? first.gmina as string : "";
                powiat = first.powiat ? first.powiat as string : "";
                wojewodztwo = first.wojewodztwo ? first.wojewodztwo as string : "";
                for (var i = 1; i < gminy?.length; i++) {
                    let next = gminy[i];
                    if (next.gmina != null && !gmina.includes(next.gmina as string)) gmina += `,\n${next.gmina}`;
                    if (next.powiat != null && !powiat.includes(next.powiat as string)) powiat += `,\n${next.powiat}`;
                    if (next.wojewodztwo != null && !wojewodztwo.includes(next.wojewodztwo as string)) wojewodztwo += `,\n${next.wojewodztwo}`;
                }
            }
        }
        createFieldsForLocation();

        ValidationErrors["gmina"] = validation(krForm?.config?.Validation["gmina"], gmina);
        ValidationErrors["powiat"] = validation(krForm?.config?.Validation["powiat"], powiat);
        ValidationErrors["wojewodztwo"] = validation(krForm?.config?.Validation["wojewodztwo"], wojewodztwo);
    }

    if (objectType === ObjectType.KRO) {
        const landslideAttributes = (krForm as KrLandslideFormTypes)?.landslideAttributes;

        for (const key of Object.keys(landslideAttributes!)) {
            if (landslideAttributes) {
                let value = landslideAttributes[key as keyof landSlideAttributes];
                if (key === "miejscowosC_NAZWA") {
                    if (!hasRelatedGmina(krForm, objectType, dictionariesForValidation)) { value = undefined; }
                }
                ValidationErrors[key] = validation(krForm.config?.Validation[key], value);
            }
        }
        ValidationErrors["waterManifestation1"] = validation(krForm?.config?.Validation["waterManifestation1"], (krForm as KrLandslideFormTypes).waters?.filter((water) => { return water.tyP_STREFY_SID === 1 }));
        ValidationErrors["waterManifestation2"] = validation(krForm?.config?.Validation["waterManifestation2"], (krForm as KrLandslideFormTypes).waters?.filter((water) => { return water.tyP_STREFY_SID === 2 }));
        ValidationErrors["waterManifestation3"] = validation(krForm?.config?.Validation["waterManifestation3"], (krForm as KrLandslideFormTypes).waters?.filter((water) => { return water.tyP_STREFY_SID === 3 }));
        ValidationErrors["waterManifestation4"] = validation(krForm?.config?.Validation["waterManifestation4"], (krForm as KrLandslideFormTypes).waters?.filter((water) => { return water.tyP_STREFY_SID === 4 }));
        ValidationErrors["rastersElements1"] = validation(krForm?.config?.Validation["rastersElements1"],
            (krForm as KrLandslideFormTypes).landslideRasters?.filter((raster) => { return (raster.details?.rodzaj === "mapa_u" || raster.details?.rodzaj === "szkic" || raster.details?.rodzaj === "mapa_a") }));
        ValidationErrors["rastersElements3"] = validation(krForm?.config?.Validation["rastersElements3"],
            (krForm as KrLandslideFormTypes).landslideRasters?.filter((raster) => { return (raster.details?.rodzaj === "foto") }), true, true);

        if ((krForm as KrLandslideFormTypes).landslideRoadDamages) {
            for (let i = 0; i < (krForm as KrLandslideFormTypes).landslideRoadDamages?.length!; i++) {
                ValidationErrors[`roadDamages${i}`] = validation(krForm?.config?.Validation[`roadDamages${i}`], (krForm as KrLandslideFormTypes).landslideRoadDamages![i].infrastrukturA_KOM_SID);
            }
        }

        if (patternType === PatternType.P2020) {
            ValidationErrors["datA_USTALENIA"] = validation(krForm?.config?.Validation["datA_USTALENIA"], (krForm as KrLandslideFormTypes).landslideAttributes?.datA_USTALENIA)
            ValidationErrors["datA_WYPELNIENIA"] = validation(krForm?.config?.Validation["datA_WYPELNIENIA"], (krForm as KrLandslideFormTypes).landslideAttributes?.datA_WYPELNIENIA)
        }

        const checkElementsCheckBox = (krFormObj: KrLandslideFormTypes) => {
            let values: string[] = [];
            if ((krFormObj.landslideAttributes?.uT_LASY === 0 || krFormObj.landslideAttributes?.uT_LASY === null) &&
                (krFormObj.landslideAttributes?.uT_ZAROSLA === 0 || krFormObj.landslideAttributes?.uT_ZAROSLA === null) &&
                (krFormObj.landslideAttributes?.uT_LAKI_PASTWISKA === 0 || krFormObj.landslideAttributes?.uT_LAKI_PASTWISKA === null) &&
                (krFormObj.landslideAttributes?.uT_GRUNTY_ORNE === 0 || krFormObj.landslideAttributes?.uT_GRUNTY_ORNE === null) &&
                (krFormObj.landslideAttributes?.uT_SADY === 0 || krFormObj.landslideAttributes?.uT_SADY === null) &&
                (krFormObj.landslideAttributes?.uT_NIEUZYTKI === 0 || krFormObj.landslideAttributes?.uT_NIEUZYTKI === null)) {

            }
            else {
                values.push("Noerror");
            }
            return values;
        }
        let values = checkElementsCheckBox(krForm);
        ValidationErrors["landUse"] = validation(krForm?.config?.Validation["landUse"], values);

    } else if (objectType === ObjectType.KRTZ) {
        const endangeredAreaAttributes = (krForm as KrEndangeredAreaFormTypes)?.endangeredAreaAttributes;
        for (const key of Object.keys(endangeredAreaAttributes!)) {
            if (endangeredAreaAttributes) {
                let value = endangeredAreaAttributes[key as keyof endangeredAreaAttributes];
                if (key === "miejscowosC_NAZWA") {
                    if (!hasRelatedGmina(krForm, objectType, dictionariesForValidation)) { value = undefined; }
                }
                ValidationErrors[key] = validation(krForm.config?.Validation[key], value);
            }
        }
        if (patternType === PatternType.P2020) {
            ValidationErrors["datA_USTALENIA"] = validation(krForm?.config?.Validation["datA_USTALENIA"], (krForm as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.datA_USTALENIA)
            ValidationErrors["datA_WYPELNIENIA"] = validation(krForm?.config?.Validation["datA_WYPELNIENIA"], (krForm as KrEndangeredAreaFormTypes).endangeredAreaAttributes?.datA_WYPELNIENIA)
        }
        ValidationErrors["rastersElements1"] = validation(krForm?.config?.Validation["rastersElements1"],
            (krForm as KrEndangeredAreaFormTypes).endangeredAreaRasters?.filter((raster) => {
                return (raster.details?.rodzaj === "mapa_u" ||
                    raster.details?.rodzaj === "szkic" || raster.details?.rodzaj === "mapa_a")
            }));
    }
    let dicts = krForm.dictionaries ? krForm.dictionaries : dictionariesForValidation
    prepareDateCheckDictValidation(objectType, dicts, krForm, ValidationErrors);

    return _assignErrorsToConfig(krForm, ValidationErrors);
}

export const validationErrorsPoForm = (poForm: poFormTypes) => {
    var ValidationErrors: Record<string, string> = {};
    if (!poForm?.config?.Validation) { return poForm; };

    for (const key of Object.keys(poForm.protocolAttributes!)) {
        if (poForm.config?.Validation && poForm.protocolAttributes) {
            ValidationErrors[key] = validation(poForm.config?.Validation[key], poForm.protocolAttributes[key as keyof ProtocolAttributes]);
        }
    }

    for (const key of Object.keys(poForm)) {
        if (poForm.config?.Validation) {
            ValidationErrors[key] = validation(poForm.config?.Validation[key], poForm[key as keyof poFormTypes]);
        }
    }

    return _assignErrorsToConfig(poForm, ValidationErrors);
}

const _assignWarningsToConfig = (form: krFormTypes | poFormTypes, ValidationErrors: Record<string, string>) => {
    const isValid = _isValid(ValidationErrors);
    return { ...form, config: { ...form.config, ValidationWarningsError: ValidationErrors, isValidWarnings: isValid } };
}

const _assignErrorsToConfig = (form: krFormTypes | poFormTypes, ValidationErrors: Record<string, string>) => {
    const isValid = _isValid(ValidationErrors);
    return { ...form, config: { ...form.config, ValidationError: ValidationErrors, isValid: isValid, check: true } };
}

const _isValid = (ValidationErrors: Record<string, string>) => {
    var validationErrorsConfirmed = [];
    Object.entries(ValidationErrors).map(item => {
        if (item[1] !== '')
            validationErrorsConfirmed.push(item[0]);
        return null;
    });
    return validationErrorsConfirmed.length === 0;
}
